import {FC} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const Error404Page: FC = () => {
  return (
    <div className='d-flex flex-column flex-root'>
      <div
        className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        style={{backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/progress-hd.png')}')`}}
      >
        <div className='d-flex flex-column flex-column-fluid text-center p-10 py-lg-20'>
          <a href='/dashboard' className='mb-10'>
            <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo.svg')} className='h-50px mb-5' />
          </a>
          <div className=' mb-10'>
            <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>Something went wrong!</h1>

            <div className='fw-bold fs-3 text-gray-400 mb-15'>
              The page you looked not found! <br /> Something went wrong
            </div>
            <div className='text-center'>
              <a href='/' className='btn btn-lg btn-primary fw-bolder'>
                Go to homepage
              </a>
            </div>
          </div>
          <div
            className='
        d-flex
        flex-row-auto
        bgi-no-repeat
        bgi-position-x-center
        bgi-size-contain
        bgi-position-y-bottom
        min-h-100px min-h-lg-350px
      '
            style={{
              backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/sketchy-1/17.png')}')`,
            }}
          ></div>
        </div>
      </div>
    </div>
  )
}

export {Error404Page}
